import React, { useContext, useEffect, useState } from 'react';
import { catalogueAction } from '../../../services/CatalogueServices';
import { useNavigate, useParams } from 'react-router-dom';
import { Card, Grid } from '@mui/material';
import { Images } from '../../../common/Assets/Images';
import { GlassMagnifier } from 'react-image-magnifiers';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Moment from 'react-moment';
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import ArtefactsDetailActions from './ArtefactsDetailActions';
import ActivityLogs from '../../../common/ActivityLogs/ActivityLogs';
import { StateContext } from '../../../store';
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';
import PageWrapper from '../../../common/PageWrapper/PageWrapper';

export default function ArtefactDetail() {
  const navigate = useNavigate();
  const { commonUpdate } = useContext(StateContext);
  const [item, setItem] = useState({});
  const params = useParams();
  const id = params.id;
  const [changeIndex, setChangeIndex] = useState(0);
  const dimensions = item?.dimensions || [];
  const [openLog, setOpenLog] = useState(false);

  useEffect(() => {
    getItemDetail();
  }, [commonUpdate, id]);

  const getItemDetail = () => {
    catalogueAction('get', id).then(res => {
      setItem(res?.data);
    })
  }

  const handleSelectedIndex = (index) => {
    setChangeIndex(index);
  }

  const formatDimensions = (dimensions) => {
    const width = dimensions?.find(dim => dim?.name === 'Width')?.value || 'N/A';
    const height = dimensions?.find(dim => dim?.name === 'Height')?.value || 'N/A';
    const length = dimensions?.find(dim => dim?.name === 'Length')?.value || 'N/A';

    return `Length ${length}cm x width/circumtance ${width}cm x Height ${height}cm`;
  };

  const formatWeight = (dimensions) => {
    const weight = dimensions?.find(dim => dim?.name === 'Weight')?.value || 'N/A';

    return `Weight ${weight} kg`;
  };

  const toggleLog = () => {
    setOpenLog(!openLog);
  }

  const handleLogClose = () => {
    setOpenLog(false);
  }

  const handleEdit = () => {
    navigate(`/management/catalogue-artefacts/create/?id=${id}&isEdit=${true}`)
  }

  const asText = (value) => {
    if (value === null || value === undefined) return '-';
    if (typeof value === 'object') {
      return value?.name || value?.code || value?.description || String(value?.id || '-');
    }
    const str = String(value);
    return str?.trim?.() ? str : '-';
  };

  return (
    <PageWrapper>
      <Box sx={{ position: 'relative' }}>
        <Box className={'space-between'} sx={{ marginTop: 5 }}>
          <Box onClick={() => navigate(-1)}
            className={'flex-cx-center hand-cursor'}>
            <ArrowBackIosRoundedIcon sx={{ color: '#757575' }} />
            <Typography variant={'h5'} sx={{ color: '#757575' }}>{item?.object_name}</Typography> &nbsp;
            (<Typography sx={{ color: '#757575' }}>{formatDimensions(dimensions)}, {formatWeight(dimensions)}</Typography>)
          </Box>
          <ArtefactsDetailActions item={item} handleEdit={handleEdit} catalogueId={id} />
        </Box>
        <Box className={'header-divider'} />
        <Grid container spacing={2}>
          <Grid item sm={5} xs={12}>
            <Card className={'box-shadow'} sx={{ width: '100%' }}>
              <GlassMagnifier
                imageSrc={item?.attachments?.[changeIndex]?.file || Images.logoWhite}
                imageAlt="Item Image"
                largeImageSrc={item?.attachments?.[changeIndex]?.file || Images.logoWhite}
                largeImageAlt="Zoomed Image"
                magnifierSize="40%"
                square
              />
            </Card>
            <Grid container spacing={1} sx={{ mt: 0.5 }}>
              {item?.attachments?.length > 0 && item?.attachments?.map((attachment, index) => (
                <Grid item sm={2.4} key={index}>
                  <Card sx={{ height: 100 }}>
                    <img onClick={() => handleSelectedIndex(index)} draggable={false} width={'100%'} height={'100%'}
                      style={{ borderRadius: 5, objectFit: 'contain' }}
                      src={attachment?.file || Images?.logoWhite}
                      alt="item_image" />
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Grid>
          <Grid item sm={7} xs={12}>
            <Card className={'box-shadow'}>
              <Box sx={{ p: 2 }}>
                <Typography className={'font20 text-500 dark-color'}>Catalog Data</Typography>
              </Box>
              <Box className={'common-divider'} />
              <Box sx={{ p: 2 }}>
                <Grid container spacing={2} sx={{ mb: 0.5 }}>
                  <Grid item sm={4}>
                    <Typography className={'dark-color font-15 text-500'}>OBJECT NAME:</Typography>
                  </Grid>
                  <Grid item sm={8}>
                    <Typography className={'font-15'}>{item?.object_name}</Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ mb: 0.5 }}>
                  <Grid item sm={4}>
                    <Typography className={'dark-color font-15 text-500'}>OWNERSHIP:</Typography>
                  </Grid>
                  <Grid item sm={8}>
                    <Typography className={'font-15'}>{asText(item?.ownership)}</Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ mb: 0.5 }}>
                  <Grid item sm={4}>
                    <Typography className={'dark-color font-15 text-500'}>ACCESSION NO: </Typography>
                  </Grid>
                  <Grid item sm={8}>
                    <Typography className={'font-15'}>{asText(item?.accession_no || item?.accession_no_legacy)}</Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ mb: 0.5 }}>
                  <Grid item sm={4}>
                    <Typography className={'dark-color font-15 text-500'}>CLASSIFICATION:</Typography>
                  </Grid>
                  <Grid item sm={8}>
                    <Typography className={'font-15'}>{asText(item?.object_group || item?.classification)}</Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ mb: 0.5 }}>
                  <Grid item sm={4}>
                    <Typography className={'dark-color font-15 text-500'}>SOURCE:</Typography>
                  </Grid>
                  <Grid item sm={8}>
                    <Typography className={'font-15'}>{asText(item?.source)}</Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ mb: 0.5 }}>
                  <Grid item sm={4}>
                    <Typography className={'dark-color font-15 text-500'}>SOURCE REMARKS:</Typography>
                  </Grid>
                  <Grid item sm={8}>
                    <Typography className={'font-15'}>{asText(item?.source_remarks)}</Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ mb: 0.5 }}>
                  <Grid item sm={4}>
                    <Typography className={'dark-color font-15 text-500'}>PRICE:</Typography>
                  </Grid>
                  <Grid item sm={8}>
                    <Typography className={'font-15'}>{asText(item?.price)}</Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ mb: 0.5 }}>
                  <Grid item sm={4}>
                    <Typography className={'dark-color font-15 text-500'}>SUB GROUP:</Typography>
                  </Grid>
                  <Grid item sm={8}>
                    <Typography className={'font-15'}>{asText(item?.object_sub_group || item?.sub_group)}</Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ mb: 0.5 }}>
                  <Grid item sm={4}>
                    <Typography className={'dark-color font-15 text-500'}>MATERIALS:</Typography>
                  </Grid>
                  <Grid item sm={8}>
                    <Typography className={'font-15'}>{asText(item?.material)}</Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ mb: 0.5 }}>
                  <Grid item sm={4}>
                    <Typography className={'dark-color font-15 text-500'}>DIMENSIONS:</Typography>
                  </Grid>
                  <Grid item sm={8}>
                    <Typography className={'font-15'}>{formatDimensions(dimensions)}, {formatWeight(dimensions)}</Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ mb: 0.5 }}>
                  <Grid item sm={4}>
                    <Typography className={'dark-color font-15 text-500'}>DYES:</Typography>
                  </Grid>
                  <Grid item sm={8}>
                    <Typography className={'font-15'}>{asText(item?.dyes)}</Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ mb: 0.5 }}>
                  <Grid item sm={4}>
                    <Typography className={'dark-color font-15 text-500'}>MOTIFS:</Typography>
                  </Grid>
                  <Grid item sm={8}>
                    <Typography className={'font-15'}>{asText(item?.motifs)}</Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ mb: 0.5 }}>
                  <Grid item sm={4}>
                    <Typography className={'dark-color font-15 text-500'}>DATE OF ACQUISITION:</Typography>
                  </Grid>
                  <Grid item sm={8}>
                    <Typography className={'font-15'}><Moment format={'ll'}>{item?.date_of_aquisition}</Moment></Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ mb: 0.5 }}>
                  <Grid item sm={4}>
                    <Typography className={'dark-color font-15 text-500'}>ACQUISITION:</Typography>
                  </Grid>
                  <Grid item sm={8}>
                    <Typography className={'font-15'}>{item?.acquisition?.name || '--'}</Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ mb: 0.5 }}>
                  <Grid item sm={4}>
                    <Typography className={'dark-color font-15 text-500'}>CONDITION:</Typography>
                  </Grid>
                  <Grid item sm={8}>
                    <Typography className={'font-15'}>{asText(item?.condition)}</Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ mb: 0.5 }}>
                  <Grid item sm={4}>
                    <Typography className={'dark-color font-15 text-500'}>LOCATION:</Typography>
                  </Grid>
                  <Grid item sm={8}>
                    <Typography className={'font-15'}>{asText(item?.storage_location || item?.location || item?.location_legacy)}</Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ mb: 0.5 }}>
                  <Grid item sm={4}>
                    <Typography className={'dark-color font-15 text-500'}>PLACE OF ORIGIN:</Typography>
                  </Grid>
                  <Grid item sm={8}>
                    <Typography className={'font-15'}>{asText(item?.place_of_origin)}</Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ mb: 0.5 }}>
                  <Grid item sm={4}>
                    <Typography className={'dark-color font-15 text-500'}>ADDITIONAL INFORMATION:</Typography>
                  </Grid>
                  <Grid item sm={8}>
                    <Typography className={'font-15'}>{asText(item?.other_info)}</Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ mb: 0.5 }}>
                  <Grid item sm={4}>
                    <Typography className={'dark-color font-15 text-500'}>CATALOGED BY:</Typography>
                  </Grid>
                  <Grid item sm={8}>
                    <Typography className={'font-15'}>{item?.user_name}</Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ mb: 0.5 }}>
                  <Grid item sm={4}>
                    <Typography className={'dark-color font-15 text-500'}>DATE OF ENTRY:</Typography>
                  </Grid>
                  <Grid item sm={8}>
                    <Typography className={'font-15'}><Moment format={'ll'}>{item?.date_of_entry}</Moment></Typography>
                  </Grid>
                </Grid>
              </Box>
            </Card>
            <Card className={'box-shadow'} sx={{ p: 2, mt: 1 }}>
              <Typography className={'dark-color font-15 text-500'}>DESCRIPTION</Typography>
              <Typography className={'font-14'}>{item?.description}</Typography>
            </Card>
            <Card className={'box-shadow'} sx={{ p: 2, mt: 1 }}>
              <Typography className={'dark-color font-15 text-500 upper-case'}>Exhibition history</Typography>
              <Typography className={'font-14'}>{item?.exhibition_history}</Typography>
            </Card>
          </Grid>
        </Grid>
        <Box sx={{ position: 'fixed', right: 0, bottom: '10%' }}>
          <Card onClick={toggleLog} className={'box-shadow'}
            sx={{
              pr: 2.5,
              pl: 2,
              pt: 1,
              pb: 1.5,
              zIndex: 20000,
              backgroundColor: '#616B88',
              borderTopLeftRadius: 50,
              borderBottomLeftRadius: 50,
              cursor: 'pointer',
            }}>
              
            <ArrowBackIosNewRoundedIcon fontSize={'small'} sx={{ color: '#fff', marginTop: 1 }} />
          </Card>
        </Box>
        <ActivityLogs openLog={openLog} handleLogClose={handleLogClose} catalogId={id} />
      </Box>
    </PageWrapper>
  );
}